const state = {
  pollData: {}
}

const getters = {

}

const mutations = {
  setPollData (state, value) {
    state.pollData = value
  }
}

const actions = {
  index ({ rootState, commit }, params) {
    return rootState.axios.get('/jyb/v1frontend/poll/index', { params }).then(res => {
      commit('setPollData', res.data.list)
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
